import { useEffect, useCallback } from 'react';
import { Device, DeviceInfo } from '@capacitor/device';
import { useGetState } from 'ahooks';

interface Props {
  onGetDeviceInfo?: (info: DeviceInfo) => void;
}

export const useDevice = (props?: Props) => {
  const [info, setInfo, getInfo] = useGetState<DeviceInfo>({} as any);

  const getDeviceInfo = useCallback(async () => {
    try {
      const data = await Device.getInfo();
      setInfo(data);
      props?.onGetDeviceInfo?.(data);
    } catch (e) {
      console.error('getDeviceInfo error:', e);
    }
  }, [props, setInfo]);

  const checkIsApp = useCallback(() => {
    return !!getInfo()?.platform && getInfo()?.platform !== 'web';
  }, [getInfo]);

  useEffect(() => {
    getDeviceInfo();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { info, checkIsApp, isIosReview: false };
};
